import { h } from "preact";

import IconProps from "./IconProps";

function IconExclamation({
    class: cssClass
}: IconProps) {
    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#eqhz4390za)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm-.001-5.663c.55 0 .98.437.98.96 0 .535-.43.966-.98.966a.964.964 0 1 1 0-1.926zm.003-6.597c.485 0 .878.393.878.878v3.768a.878.878 0 1 1-1.756 0V4.618c0-.485.393-.878.878-.878z" fill="#EE6723"/>
            </g>
            <defs>
                <clipPath id="eqhz4390za">
                    <path fill="#fff" d="M0 0h16v16H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconExclamation;
